// extracted by mini-css-extract-plugin
export default {"wrapper":"Vfa","container":"Wfa","box":"Xfa","title":"Yfa","rdwrap":"Zfa","rditem":"aga","rdimage":"bga","name":"cga","heading":"ega","text":"fga","guarantee":"gga","chatbox":"hga"};
    if(module.hot) {
      // 1730991513155
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  